module.exports = __webpack_public_path__ + "img/haoli_pc.724ece88.png";